import type * as React from "react";
import { cn } from "cn";

export interface IconButtonProps {
  /** The icon node (~18px). */
  icon: React.ReactNode;
  /** @default "secondary" */
  variant?: "solid" | "secondary" | "ghost";
  /** @default "md" */
  size?: "sm" | "md" | "lg";
  /** @default "rounded" */
  shape?: "rounded" | "circle";
  disabled?: boolean;
  /** Required for accessibility. */
  ariaLabel?: string;
  /** Native tooltip text. */
  title?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  style?: React.CSSProperties;
}


const sizes = {sm: "size-8", md: "size-10", lg: "size-[46px]"};
const variants = {
  solid: "border-transparent bg-primary text-primary-foreground shadow-sm enabled:hover:bg-[var(--accent-hover)]",
  secondary: "border-input bg-card text-card-foreground shadow-xs enabled:hover:bg-accent",
  ghost: "border-transparent bg-transparent text-[var(--text-secondary)] enabled:hover:bg-accent",
};
export function IconButton({icon, variant = "secondary", size = "md", shape = "rounded", disabled = false,
  ariaLabel, title, onClick, style}: IconButtonProps) {
  return <button type="button" data-slot="icon-button" aria-label={ariaLabel} title={title}
    disabled={disabled} onClick={onClick} style={style} className={cn(
      "inline-grid shrink-0 place-items-center border border-solid p-0 outline-none transition-colors focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:opacity-50",
      sizes[size], variants[variant], shape === "circle" ? "rounded-full" : "rounded-md"
    )}>{icon}</button>;
}
